import {UPDATED} from '../actions/wallet'

export default function wallet(state = {}, action = {}) {
  switch (action.type) {
    case UPDATED:
      return {
        ...state,
        votesLeftUntilFreePoint: action.votesLeft,
        freePointsDisabled: action.disabled,
        credits: action.credits,
        freePoints: action.freePoints
      }
    default:
      return state
  }
}